/**
 * Workspace Constants
 * Matching backend WorkspaceConstants.cs for frontend validation
 */

// ===== WORKSPACE LIMITS (matching backend) =====

/** Maximum length for workspace name */
export const WORKSPACE_NAME_MAX_LENGTH = 100;

/** Minimum length for workspace name */
export const WORKSPACE_NAME_MIN_LENGTH = 3;

/** Maximum length for workspace description */
export const WORKSPACE_DESCRIPTION_MAX_LENGTH = 1000;

// ===== INVITATION LIMITS (matching backend) =====

/** Maximum length for invitation message */
export const INVITATION_MESSAGE_MAX_LENGTH = 500;

/** Maximum number of invitations in a single batch */
export const INVITATION_BATCH_MAX_SIZE = 50;

/** Invitation expiration days (for display purposes) */
export const INVITATION_EXPIRATION_DAYS = 7;

// ===== PAGINATION (matching backend) =====

/** Default page size for workspace lists */
export const WORKSPACE_DEFAULT_PAGE_SIZE = 20;

/** Maximum allowed page size */
export const WORKSPACE_MAX_PAGE_SIZE = 100;

// ===== UI CONSTANTS =====

/** Debounce delay for search input (milliseconds) */
export const WORKSPACE_SEARCH_DEBOUNCE_MS = 300;

/** Height of member/invitation list item for layout calculations (pixels) */
export const WORKSPACE_LIST_ITEM_HEIGHT = 72;

/** Minimum items before considering virtualization */
export const WORKSPACE_VIRTUALIZATION_THRESHOLD = 50;

/** Panel width for workspace management (pixels) */
export const WORKSPACE_PANEL_WIDTH = 520;

/** Storage key for workspace panel width */
export const WORKSPACE_PANEL_STORAGE_KEY = 'geomarkup-workspace-panel-width';

// ===== ROLE OPTIONS =====

/** Roles available for invitation (excludes Owner) */
export const INVITABLE_ROLES = ['Admin', 'Editor', 'Viewer'] as const;

// ===== ROLE DISPLAY COLORS =====

/** Role colors for badges (Mantine color names) */
export const WORKSPACE_ROLE_COLORS: Record<string, string> = {
  Owner: 'orange',
  Admin: 'indigo',
  Editor: 'green',
  Viewer: 'gray',
} as const;

/** Invitation status colors for badges (Mantine color names) */
export const INVITATION_STATUS_COLORS: Record<string, string> = {
  Pending: 'yellow',
  Accepted: 'green',
  Expired: 'gray',
  Revoked: 'red',
} as const;
